<template>
  <v-app v-if="articleInfoValue">
    <v-container fluid class="article-actions">
      <v-row>
        <v-col cols="2">
          <v-subheader>عنوان</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="عنوان" v-model="title"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>ترتیب نمایش</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            placeholder="ترتیب نمایش"
            v-model="priority"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>تصویر</v-subheader>
        </v-col>
        <v-col cols="8">
          <!-- <ImageUploader :imageUrl="image" @image-file="imageFile" /> -->
          <label for="image-input1" id="image-input1-text" @click="imgInput1"
            >انتخاب فایل</label
          >
          <input
            type="file"
            @change="onFileSelected1"
            id="image-input1"
            value="انتخاب فایل"
          />
          <img
            :src="imgSrc"
            v-show="imgSrc"
            id="image_0"
            height="150"
            width="150"
            alt=""
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>دسته بندی</v-subheader>
        </v-col>
        <v-col cols="8">
          دسته انتخاب شده : <v-chip color="green darken-3 white--text">{{productGroupTitle ?productGroupTitle :'انتخاب نشده'}}</v-chip>
          <Treeview
            :items="categoryList"
            @productCategory="
              (e) => {
                productParentId = e;
              }
            "
          />
        </v-col>
      </v-row>
      <v-row justify="center mb-3">
        <v-btn
          class="ml-4 white--text font-weight-bold indigo darken-4 white--text"
          @click="editHandler"
        >
          ثبت کردن
        </v-btn>
        <router-link to="/productIndex">
          <v-btn class="white--text font-weight-bold indigo lighten-2">
            انصراف
          </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import baseURL from "@/axios";
import Treeview from './Treeview.vue'
export default {
  components:{Treeview},
  created() {
    axios
      .get(`${baseURL}CategoryIndex/GetById?id=${this.$route.params.id}`)
      .then((res) => {
        this.imgSrc = res.data.data.image;
        this.priority = res.data.data.priority;
        this.title = res.data.data.title;
        this.productGroupTitle = res.data.data.productGroupTitle;
        this.productParentId=res.data.data.productGroupId
        res.data.data.products.map((item) => {
          this.product.push({
            value: item.productGroupId,
            text: item.productGroupTitle,
          });
        });
      });
    axios.get(`${baseURL}ProductGroup/GetAll`).then((res) => {
      res.data.data.map((item) => {
        this.products.push({
          text: item.name,
          value: item.id,
        });
      });
    });

    axios.get(`${baseURL}ProductGroup/GetAll`).then((res) => {
      this.categoryList = res.data.data;
    });
  },

  data() {
    return {
      id: null,
      title: "",
      description: "",
      nationalCode: "",
      homePhone: null,
      address: "",
      bio: "",
      postalCode: "",
      geoDivisionId: "",
      priority:null,
      image: null,
      image1: null,
      imgSrc: null,
      imgSrc1: null,
      productParentId:0,
      productGroupTitle:'',
      showDatepicker: false,
      product: [],
      categoryList:[],
      state: {
        value: null,
        text: null,
      },
      products: [],
      city: {
        value: null,
        text: null,
      },
      cities: [],
      selectItem: "null",
    };
  },
  computed: {
    ...mapGetters(["tokenValue", "articleInfoValue", "itemList"]),
  },
  methods: {
    closeDatePicker() {
      this.showDatepicker = false;
    },
    showDate() {
      this.showDatepicker = true;
    },
    onFileSelected(event) {
      this.image = event.target.files[0];
      this.imgSrc1 = URL.createObjectURL(event.target.files[0]);
    },
    onFileSelected1(event) {
      this.image1 = event.target.files[0];
      this.imgSrc = URL.createObjectURL(event.target.files[0]);
    },
    imageFile(value) {
      this.imageFile = value;
    },
    imageFile1(value) {
      this.imageFile1 = value;
    },
    async editHandler() {
      //   this.list.map((item) => {
      //     if (item.title == this.selectItem) {
      //       this.selectItem = item.id;
      //     }
      await axios
        .put(
          `${baseURL}CategoryIndex/Edit`,
          {
            id: parseInt(this.$route.params.id),
            title: this.title,
            productGroupId: this.productParentId,
            priority: this.priority,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then((res) => {
          //   this.$router.push("/offer-off/discountCode");
          const resp = res;

          const fd = new FormData();
          fd.append("image", this.image1);
          axios
            .post(`${baseURL}CategoryIndex/UploadImage?id=${resp.data.data.id}`, fd, {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                "Content-Type": "multipart/form-data",
              },
            })
            .then(() => {this.$router.push('/productIndex') });
        })
    },
    async changeHandler() {
      await axios
        .get(`${baseURL}GeoDivision/GetById?id=${this.state}`)
        .then((res) => {
          res.data.data.children.map((item) => {
            this.cities.push({
              text: item.title,
              value: item.id,
            });
          });
        });
    },
    imgInput1() {
      // document.getElementById('image-input1').click()
    },
    imgInput() {
      // document.getElementById('image-input').click()
    },
  },
};
</script>

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
.pdp .pdp-group .pdp-input {
  border: none;
}
.pdp .pdp-group {
  border-bottom: 1px solid #949494;
}
#image-input,
#image-input1 {
  width: 0px;
}
#image_0,
#image_1 {
  background-size: cover;
  object-fit: contain;
}
</style>